export const locale = {
    lang: 'es',
    data: {
        'NAV': {
            'APPLICACIONES': 'Aplicaciones',
            'DASHBOARDS'  : 'Dashboards',
            'CALENDAR'    : 'Calendario',
            'ECOMMERCE'   : 'E-Comemerce',
            'ACADEMY'     : 'Academy',
            'MAIL'        : {
                'TITLE': 'correo',
                'BADGE': '25'
            },
            'MAIL_NGRX'        : {
                'TITLE': 'Mail Ngrx',
                'BADGE': '13'
            },
            'CHAT'        : 'Chat',
            'FILE_MANAGER': 'File Manager',
            'CONTACTS'    : 'Contacts',
            'TODO'        : 'To-Do',
            'SCRUMBOARD'  : 'Scrumboard'
        }
    }
};
